import React, { useEffect } from 'react';
import { formatArea, validateLpArea } from './utils';
import { parseDecimal, toDecimalPoint } from '../../../utils/decimalUtils';
import DecimalInput from '../../fields/DecimalInput';

const ForestPathVydelSection = ({ displayData, localFormData, setLocalFormData }) => {
  const displayedLpvid = displayData.lpvid || '1';
  const displayedSlp = displayData.slp || displayData.sga || '';

  // Единицу по умолчанию мало показать — её нужно записать в данные формы.
  // Иначе номер уезжает на сервер пустым: в вебе на экране «1», а в документе
  // lpvid: "", и другие клиенты (мобильное приложение) не показывают ничего.
  useEffect(() => {
    if (!displayData.lpvid) {
      setLocalFormData(prev => ({ ...prev, lpvid: '1' }));
    }
  }, [displayData.lpvid, setLocalFormData]);

  useEffect(() => {
    if (!displayData.slp && displayData.sga) {
      setLocalFormData(prev => ({ ...prev, slp: displayData.sga }));
    }
  }, [displayData.slp, displayData.sga, setLocalFormData]);

  return (
    <div className="group-section">
      <h4>Лесопатологический выдел</h4>
      <div>
        <table className="table">
          <thead>
            <tr>
              <th>№ <span className="required">*</span></th>
              <th>S, га <span className="required">*</span></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="coordinate-cell">
                <input
                  type="text"
                  name="lpvid"
                  id="form1-lpvid"
                  value={displayedLpvid}
                  onChange={(e) => {
                    const newData = { ...localFormData, lpvid: e.target.value };
                    setLocalFormData(newData);
                    if (setLocalFormData) {
                      setLocalFormData(prev => ({ ...prev, lpvid: e.target.value }));
                    }
                  }}
                  title="Проверьте корректность данных"
                  className={`form-control ${!displayedLpvid ? 'required-field' : ''} coordinate-field`}
                />
              </td>
              <td className="coordinate-cell">
                <DecimalInput
                  name="slp"
                  id="form1-slp"
                  value={displayedSlp}
                  onChange={(e) => {
                    const value = toDecimalPoint(e.target.value);
                    const newData = { ...localFormData, slp: value };
                    setLocalFormData(newData);
                    if (setLocalFormData) {
                      setLocalFormData(prev => ({ ...prev, slp: value }));
                    }
                  }}
                  onBlur={(e) => {
                    const value = e.target.value;
                    let formattedValue = formatArea(value);
                    
                    // Проверяем валидацию площади лесопатологического выдела
                    if (formattedValue && !validateLpArea(formattedValue, parseDecimal(localFormData.sga) || 0)) {
                      const taxArea = parseDecimal(localFormData.sga) || 0;
                      if (taxArea > 0) {
                        alert(`Ошибка: Площадь лесопатологического выдела (${formattedValue} га) не может превышать площадь лесотаксационного выдела (${taxArea.toFixed(4)} га).`);
                        formattedValue = formatArea(taxArea);
                      }
                    }
                    
                    const newData = { ...localFormData, slp: formattedValue };
                    setLocalFormData(newData);
                    if (setLocalFormData) {
                      setLocalFormData(prev => ({ ...prev, slp: formattedValue }));
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === '-' || e.key === 'Minus') {
                      e.preventDefault();
                    }
                  }}
                  placeholder="0.0000"
                  className={`form-control ${!displayedSlp || !validateLpArea(displayedSlp, parseDecimal(localFormData.sga) || 0) ? 'required-field' : ''} coordinate-field`}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ForestPathVydelSection;

